class Storage {
    setItemLocalStorage(key: string, value: any) {
        if (!key || !value) return;
        return localStorage.setItem(key, JSON.stringify(value));
    }
    getItemLocalStorage(key: string) {
        if (!key) return;
        const item = JSON.parse(localStorage.getItem(key) as string);
        if (!!item) return item;
        return '';
    }
    removeItemLocalStorage(key: string) {
        if (!key) return
        return localStorage.removeItem(key);
    }
}
const browserStorage = new Storage();
export default browserStorage;